import { render, staticRenderFns } from "./create.vue?vue&type=template&id=1e071bb6&scoped=true&"
import script from "./create.vue?vue&type=script&lang=ts&"
export * from "./create.vue?vue&type=script&lang=ts&"
import style0 from "./create.vue?vue&type=style&index=0&id=1e071bb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e071bb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e071bb6')) {
      api.createRecord('1e071bb6', component.options)
    } else {
      api.reload('1e071bb6', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=1e071bb6&scoped=true&", function () {
      api.rerender('1e071bb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_payment-plan/create.vue"
export default component.exports